// extracted by mini-css-extract-plugin
module.exports = {"bulkActions":"VolumeBulkActions_bulkActions-1niJA"};